import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { ForumEvenementPartService } from '@app/_shared/_services/forum/evenement-part.service';
import { ForumEvenementService } from '@app/_shared/_services/forum/evenement.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import * as _ from "underscore"
@Component({
  selector: 'app-cllajinscriptionsalons',
  templateUrl: './cllajinscriptionsalons.component.html',
  styleUrls: ['./cllajinscriptionsalons.component.scss']
})
export class CllajinscriptionsalonsComponent implements OnInit {

  @Output() onNextStep:EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep:EventEmitter<any> = new EventEmitter<any>();

  canNextStep:boolean =false;
  subscriptions: any = [];
  currentUser: user;


  petitssalons;

  listPro = [
    "Atelier : J'assure mon envol - 14h30",
    "Huissier de justice",
    "Avocat",
    "Service fiscaux",
    "Pôle emploi",
    "Architecte / Décoratrice d'intérieur"
  ]
  formCheck = {
    selection: null,
    commentaire: null,
    offres: null,
    activites:{}
  };

  offresVisible: boolean = false;;
  constructor(
    public authenticationService: AuthenticationService,
    public inscriptionService:ForumInscriptionService,
    private evenementService: ForumEvenementService,
    public globalHelper:GlobalHelper,
    private evenementPartService: ForumEvenementPartService) {
      this.subscriptions.push(
        this.authenticationService.currentUser.subscribe(
          (x) => {
            this.currentUser = x; }
        )
      );
    }

    ngOnInit(): void {
      console.log('on init')
      if(typeof this.inscriptionService.form?.salons == "undefined")
      this.inscriptionService.form.salons = {}
      if(typeof this.inscriptionService.form?.salons?.petitsalon_rdv == "undefined")
      this.inscriptionService.form.salons.petitsalon_rdv = {selection:null,commentaire:null}
      if(typeof this.inscriptionService.form?.salons?.petitsalon_offres == "undefined")
      this.inscriptionService.form.salons.petitsalon_offres = {selection:null,commentaire:null}

      this.refreshSalons()
      this.checkCanNextStep()
    }
      ngOnDestroy() {
        _.each(this.subscriptions, (sub) => sub.unsubscribe());
      }

      refreshSalons(){
        console.log('refreshSalons',this.evenementService?.selectedItem)
        this.evenementPartService.getItems({where:{idEvenement:this.evenementService?.selectedItem?.id,idParent:null}},[['ordre','asc']]).subscribe(res=>{
          this.petitssalons = res.items.map(i => {
              i.childrens = _.sortBy(i.childrens, c => c.ordre);
              return i
          });

          this.checkCanNextStep()
        },err=>{

        })
      }

      isSelectedItem(item){
        for (let index = 0; index < this.inscriptionService.form.salons.selectedItems.length; index++) {
          const element = this.inscriptionService.form.salons.selectedItems[index];
          if(element && element?.id == item.id)
            return true;
        }
        return false;
      }
      selectItem(item){
        if(item)
        this.inscriptionService.form.salons.selectedItems.push(_.clone(item));
        this.checkCanNextStep()
      }
      unselectItem(item){
        for (let index = 0; index < this.inscriptionService.form.salons.selectedItems.length; index++) {
          const element = this.inscriptionService.form.salons.selectedItems[index];
          if(element && element?.id == item.id){
             this.inscriptionService.form.salons.selectedItems.splice(index, 1);
            break;
          }
        }
        // unselect all childrens
        let childrens = _.find(this.petitssalons, ac => ac.id == item.id)?.childrens;
        if(childrens){
          _.each(childrens, c => {
             this.unselectItem(c)
          })
        }
        this.checkCanNextStep()
      }

      checkCanNextStep(){
        this.formCheck = {
          selection: null,
          commentaire: null,
          offres: null,
          activites:{}
        };
        this.canNextStep = false;
        let nbCheck = 0;
        let nbError = 0;
        if(this.inscriptionService.form.salons.selectedItems.length > 0){

          console.log('this.inscriptionService.form.salons.selectedItems',this.inscriptionService.form.salons.selectedItems)
          // petitsalon_rdv
          let selectedPetitsalonRdv = _.find(this.inscriptionService.form.salons.selectedItems, ps => ps?.type == "petitsalon_rdv")
          if(selectedPetitsalonRdv){
            // nbCheck++;
            if(!this.inscriptionService.form.salons.petitsalon_rdv.selection)
            this.formCheck.selection = {
              hasError: true,
              message: 'Veuillez choisir un professionnel à rencontrer',
            };
            if(!this.inscriptionService.form.salons.petitsalon_rdv.commentaire)
            this.formCheck.commentaire = {
              hasError: true,
              message: 'Veuillez indiquer la raison pour laquelle vous souhaitez le rencontrer',
            };
            if(!this.inscriptionService.form.salons.petitsalon_rdv.selection || !this.inscriptionService.form.salons.petitsalon_rdv.commentaire)
              nbError++;
          }

          // petitsalon_offres
          let selectedPetitsalonOffres = _.find(this.inscriptionService.form.salons.selectedItems, ps => ps?.type == "petitsalon_offres")
          if(selectedPetitsalonOffres){
            // nbCheck++;
            if(!this.inscriptionService.form.offres.selectedItems.length)
            this.formCheck.offres = {
              hasError: true,
              message: 'Veuillez sélectionner au moins une offre',
            };
            if(!this.inscriptionService.form.offres.selectedItems.length)
              nbError++;
          }


          let selectedActivitesWithChildrens = _.filter(this.inscriptionService.form.salons.selectedItems, ps => ps?.childrens?.length)
          if(selectedActivitesWithChildrens){
            // check if as children selected
            _.each(selectedActivitesWithChildrens, sawc => {
              console.log('sawc',sawc)
              let hasUnselectedChildren:boolean  = false;
              if(!_.find(sawc.childrens, c => _.find(this.inscriptionService.form.salons.selectedItems, ps => ps?.id == c.id)))
                hasUnselectedChildren  = true
              if(hasUnselectedChildren){
              this.formCheck.activites[sawc.id] = {
                hasError: true,
                message: 'Veuillez sélectionner au moins une activité',
              };
              nbError++;
            }
            })
          }
          // other
          // let selectedOther = _.find(this.inscriptionService.form.salons.selectedItems, ps => ps?.type == "petitsalon_delivrance")
          // if(selectedOther){
            nbCheck = _.pluck(this.inscriptionService.form.salons.selectedItems, 'type').length;
            // if(!this.inscriptionService.form.offres.selectedItems.length)
            //   nbError++;
          // }

          if(nbCheck > 0 && !nbError)
          this.canNextStep = true;
        }
        this.inscriptionService.saveFormSessionStorage()
      }


  nextStep(){
    if(this.canNextStep){
      this.onNextStep.emit()
    }
    else this.checkCanNextStep()
  }
  prevStep(){
      this.onPrevStep.emit()
  }

  toggleOffres(){
    this.offresVisible = !this.offresVisible

    this.checkCanNextStep()
  }
}
